<script>
import { mapState, mapActions } from "vuex";

import freshDesk from "@/utils/freshDesk";
import TermsOfUse from "./TermsOfUse";

export default {
  components: {
    TermsOfUse
  },

  data() {
    return {
      termsOfUse: null,
      accepted: null,
      loader: false
    };
  },

  methods: {
    ...mapActions("accountTermsOfUse", [
      "submitTermsOfUseResponse",
      "getTermsOfUse"
    ]),
    ...mapActions("user", ["refreshUser"]),
    async submit() {
      if (!this.canSubtmit) {
        this.$toasted.error(
          "Você precisa selecionar uma das opções para continuar."
        );
        return;
      }

      this.loader = true;

      try {
        await this.submitTermsOfUseResponse({
          accepted: this.accepted,
          termsOfUseId: this.termsOfUse.id
        });

        await this.refreshUser();

        window.location.reload();
      } catch (e) {
        this.$toasted.error(e);
      }

      this.loader = false;
    },

    async getTermOfUse() {
      try {
        this.termsOfUse = await this.getTermsOfUse();
      } catch (e) {
        this.$toasted.error(e);
      }
    },

    openFreshdesk() {
      freshDesk.open("ticketForm");
    }
  },

  computed: {
    ...mapState("user", ["user"]),
    canSubtmit() {
      return this.accepted != null;
    }
  },

  mounted() {
    this.getTermOfUse();
  }
};
</script>

<template>
    <div class="container">
      <div class="row">
        <div class="card align-center">
          <img src="../../../static/logo.svg" class="logo-color">

          <h4>
            Atualização dos Termos de Uso e Serviços
          </h4>

          <div class="text">
            <p>
              Com a evolução dos nossos produtos e serviços, nós da Donamaid estamos atualizando os nossos Termos de Uso e Serviços. Para continuar utilizando a Donamaid é necessário ler e aceitar o documento atualizado abaixo.
            </p>

            <div class="terms">
              <TermsOfUse/>
            </div>

            <p class="support">
              Caso você tenha ficado com alguma dúvida estamos sempre a disposição, então não hesite em nos contatar
              <b
                class="freshdesk"
                @click="openFreshdesk"
              >
                clicando aqui.
              </b>
            </p>
          </div>

          <form @submit.prevent="submit">
            <div class="options">
              <div class=" radio-group">
                <div class="option">
                  <input id="accept" type="radio" name="response" :value="true" v-model="accepted" />
                  <label class="option-text" for="accept">Declaro que li e aceito os Termos de Uso</label>
                </div>
              </div>
              <!-- <div class="radio-group">
                <div class="option">
                  <input id="reject" type="radio" name="response" :value="false" v-model="accepted" />
                  <label class="option-text" for="reject">Li e discordo dos termos</label>
                </div>
              </div> -->
            </div>

            <div class="btn-group">
              <button
                type="submit"
                class="btn bg-purple"
                :class="{'btn--loading': loader}"
              >
                <span>Confirmar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<style scoped>
.logo-color {
  width: 310px;
  height: 54px;
  display: block;
}

.text {
  width: 100%;
  font-size: 16px;
  line-height: 1.25rem;
  text-align: justify;
}

.card {
  width: calc(100% - 48px);
  transition: all 0.25s ease;
}

.terms {
  height: 400px;
  padding: 8px 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.freshdesk {
  color: var(--purple);
  cursor: pointer;
}

.support {
  font-size: 12px;
}

form {
  width: 100%;
}

input {
  margin: 0 8px 0 0;
  transform: scale(1.5);
}

.options {
  display: flex;
  flex-direction: column;
}

.option {
  display: flex;
  align-items: center;
}

.option-text {
  margin-top: 3px;
  font-size: 16px;
  font-weight: 400;
}

.btn-group {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/TermsOfUse/Index.vue